import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {Navigate, useNavigate} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import {clearError, signIn} from '../reducers/recordsSlice';

import CredentialsForm from '../forms/CredentialsForm';

import HeadingRow from '../components/HeadingRow';

import FooterRow from '../components/FooterRow';

import {ModalInfo} from 'pac-ux-components';

import {clearSelection} from 'features/accounts/reducers';

import {credentialsErrorSelector, forcePasswordChangeSelector,} from '../selectors';

import {useAccount} from 'hooks/useAccount';

export const IndexPage = () => {
    const navigate = useNavigate();

    const account = useAccount();

    const dispatch = useDispatch();

    const errorMessage = useSelector((state) =>
        credentialsErrorSelector(state)
    );

    const forcePasswordChange = useSelector((state) =>
        forcePasswordChangeSelector(state)
    );

    const handleSubmit = (values) => {
        dispatch(
            signIn({
                account: account,
                username: account['emailAddress'],
                password: values.password,
            })
        );
    };

    const handleCancel = () => {
        dispatch(clearSelection());
    };

    if (typeof account === 'undefined' || account === null) {
        return <Navigate to="/404" />;
    }

    if (forcePasswordChange === true) {
        return <Navigate to={`/change-password/${account.id}`} />;
    }

    if (errorMessage) {
        return (
            <ModalInfo
                label=""
                onClose={() => {
                    dispatch(clearError());
                    navigate(`/credentials/${account.id}`);
                }}
                text={errorMessage}
                title={I18n.get('Sign In Error')}
            />
        );
    }

    return (
        <div>
            <HeadingRow title={I18n.get('Sign In')} />
            <CredentialsForm
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                emailAddress={account['emailAddress']}
            />
            <FooterRow account={account} />
        </div>
    );
};
